import React from 'react';
import { Form, Input } from 'antd';
import { LockOutlined } from '@ant-design/icons';

const FormItem = Form.Item;

type Props = {
  form: any;
  propertyName: string;
  label?: string;
  colon?: boolean;
  value?: string;
  icon?: boolean;
  required?: boolean;
  placeholder?: string;
  formItemLayout?: any;
  maxLength?: number;
  onChange?: any;
  rules?: any[];
  validator?: any;
  requiredMsg?: string;
  withShowHideIcon: boolean;
};

const InputPasswordSimple = (props: Props) => {
  const {
    label,
    propertyName,
    required,
    placeholder,
    maxLength,
    icon,
    validator,
    requiredMsg,
    formItemLayout,
    withShowHideIcon
  } = props;

  const prefix = icon ? <LockOutlined style={{ fontSize: 15 }} /> : '';

  return (
    <FormItem
      hasFeedback
      label={label ? label : ''}
      name={propertyName}
      {...formItemLayout}
      rules={[
        { required, message: requiredMsg || `Please provide a password.` },
        {
          validator: validator || ''
        }
      ]}
    >
      {withShowHideIcon ? (
        <Input.Password prefix={prefix} placeholder={placeholder || 'Password'} maxLength={maxLength || 30} />
      ) : (
        <Input prefix={prefix} type="password" placeholder={placeholder || 'Password'} maxLength={maxLength || 30} />
      )}
    </FormItem>
  );
};
export default InputPasswordSimple;
